import platform from 'platform';
import React from 'react';

/**
 * ダウンロードリンク用の属性
 */
export type IDownloadAnchor = Pick<HTMLAnchorElement, 'download' | 'href'>;

/**
 * IE向けにダウンロードリンクを再現するclickイベントハンドラ
 */
export const downloadAnchorForIe = (() => {
	switch (platform.name) {
		// IE用にダウンロードスクリプトを仕込む
		case 'IE':
			return ({ download, href }: IDownloadAnchor) =>
				(() => {
					const xhr = new XMLHttpRequest();
					xhr.open('GET', href);
					xhr.responseType = 'blob';

					xhr.onloadend = () => {
						if (xhr.status !== 200) {
							console.error(
								`fail to download ${download} (${href})`,
								xhr
							);
							return;
						}
						if (!window.navigator.msSaveBlob) {
							console.error(
								`navigator doesnt have msSaveBlob()`,
								window.navigator
							);
							return;
						}
						window.navigator.msSaveBlob(xhr.response, download);
					};
					xhr.send();
				}) as React.MouseEventHandler<unknown>;
		// そうでない場合は使わないのでundefined
		default:
			return;
	}
})();

/**
 * download属性付きリンクの指定内容をIEモード向けにのみclickイベントに変換して返す
 * @param target anchorの情報
 */
export const handleDownloadLinkPropsForIe = (target: IDownloadAnchor) =>
	downloadAnchorForIe
		? // IEの時はonClickで専用スクリプト
		  {
				onClick: downloadAnchorForIe(target),
		  }
		: // その他EdgeやChromeではそのまま動く
		  target;



// WEBPACK FOOTER //
// ./src/utils/download.ts